import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { SettingsDTO } from './useClientSettingsQuery';
import { selectCurrentClient } from '../../CommonSelectors/CommonAreaSelector';
import { refetchCurrentClient } from '../../AdviserArea/AdviserAreaActions';
import { isDemoSelector } from '../../AdviserArea/AdviserAreaSelector';

const saveClientSettings = (clientId: number) => (params: SettingsDTO) => {
  const payload = {
    ...params,
    clientId,
  };

  return authFetch('/Consumer/ClientSettingsUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions(payload, true),
  });
};

export const useClientSettingsMutation = () => {
  const { Id: clientId } = useSelector(selectCurrentClient);
  const isDemo = useSelector(isDemoSelector);

  const dispatch = useDispatch();

  return useMutation(saveClientSettings(clientId), {
    async onSuccess() {
      await dispatch(refetchCurrentClient(clientId, isDemo));
    },
  });
};
